module.exports = __webpack_public_path__ + "img/duigou.33df6658.png";